import * as React from "react";
import { camelize } from "humps";
import { withTranslation, WithTranslation } from "react-i18next";
import { BedGroup } from "main/javascripts/models/BedGroup";
import { BedConfiguration } from "main/javascripts/models/BedConfiguration";

export interface IProps {
  bedGroups: BedGroup[];
  t?: any;
}

const HotelBedInfoComponent: React.FC<IProps & WithTranslation> = (
  props: IProps
): React.ReactElement | null => {
  const { bedGroups, t } = props;

  const renderBedTypes: () => any = (): any => {
    return bedGroups.map((bedGroup: BedGroup, groupIndex: number) => {
      return bedGroup.configurations.map(
        (configuration: BedConfiguration, index: number) => {
          const bedTypeSizeText: string = t(
            `constant:hotelBedSizeType.${configuration.sizeType}`
          );
          return (
            <React.Fragment key={index}>
              {index > 0 && <span> + </span>}
              {groupIndex > 0 && index === 0 && (
                <span> {t("label:common.or")} </span>
              )}
              <span>
                {t(`unit:${camelize(configuration.bedType)}`, {
                  type: bedTypeSizeText,
                  count: configuration.count,
                })}
              </span>
            </React.Fragment>
          );
        }
      );
    });
  };
  return <>{renderBedTypes()}</>;
};
export const HotelBedInfo: any = React.memo(
  withTranslation(["label", "unit"])(HotelBedInfoComponent)
);
